const CLAMP_FROM_LENGTH = 270;
const CLAMP_AT_LINES = 8;
const ELLIPSIS_CHARACTER = '…';

export function bootstrap() {

  const notesAndFigures = document.querySelectorAll('.s-sci-prose__fn-content, figure');
  if (notesAndFigures.length < 1) { return; }

  const firstNote = document.querySelector('.s-sci-prose__fn-content');
  if (!firstNote) { return; }

  const marginBottom = parseInt(window.getComputedStyle(
    firstNote,
    ).marginBottom, 10);
  
  for (let i = 0; i < notesAndFigures.length - 1; i++) {
    // For each note except the last one
    const note = notesAndFigures[i];
    if (!note.classList.contains('s-sci-prose__fn-content')) { continue; }

    const curRect = note.getBoundingClientRect(),
          nextRect = notesAndFigures[i+1].getBoundingClientRect();

    if ((nextRect.top - curRect.bottom) <= marginBottom &&
      note.innerText.length >= CLAMP_FROM_LENGTH) {
      
      // 
      const noteOriginal = note.cloneNode(true);
      lineClamp(note, CLAMP_AT_LINES);
      const noteClamped = note.cloneNode(true);

      note.addEventListener('mouseenter', e => {
        // Remove children
        let child;
        while (child = note.lastChild) {
          note.removeChild(child);
        }

        // Copy original content
        for (const childOriginal of noteOriginal.childNodes) {
          note.appendChild(childOriginal.cloneNode(true));
        }
      });

      note.addEventListener('mouseleave', e => {
        // Remove children
        let child;
        while (child = note.lastChild) {
          note.removeChild(child);
        }

        // Copy clamped content
        for (const childClamped of noteClamped.childNodes) {
          note.appendChild(childClamped.cloneNode(true));
        }
      });
    }
  }
  
}

// line-clamp by @yuanqing (slightly modified)
// © 2018 Lim Yuan Qing / MIT License
// https://github.com/yuanqing/line-clamp/tree/main
function lineClamp (rootElement, lineCount) {
  const maximumHeight =
    (lineCount || 1) *
    parseInt(window.getComputedStyle(rootElement).lineHeight, 10)

  // Exit if text does not overflow `rootElement`.
  if (rootElement.scrollHeight <= maximumHeight) {
    return false
  }

  return truncateElementNode(
    rootElement,
    rootElement,
    maximumHeight,
    ELLIPSIS_CHARACTER
  )
}

function truncateElementNode (
  element,
  rootElement,
  maximumHeight,
  ellipsisCharacter
) {
  const childNodes = element.childNodes
  let i = childNodes.length - 1
  while (i > -1) {
    const childNode = childNodes[i--]
    if (
      (childNode.nodeType === 1 &&
        truncateElementNode(
          childNode,
          rootElement,
          maximumHeight,
          ellipsisCharacter
        )) ||
      (childNode.nodeType === 3 &&
        truncateTextNode(
          childNode,
          rootElement,
          maximumHeight,
          ellipsisCharacter
        ))
    ) {
      return true
    }
    element.removeChild(childNode)
  }
  return false
}

function truncateTextNode (
  textNode,
  rootElement,
  maximumHeight,
  ellipsisCharacter
) {
  let lastIndexOfWhitespace
  let textContent = textNode.textContent
  while (textContent.length > 1) {
    lastIndexOfWhitespace = textContent.lastIndexOf(' ')
    if (lastIndexOfWhitespace === -1) {
      break
    }
    textNode.textContent = textContent.substring(0, lastIndexOfWhitespace)
    if (rootElement.scrollHeight <= maximumHeight) {
      textNode.textContent = textContent
      break
    }
    textContent = textNode.textContent
  }
  return truncateTextNodeByCharacter(
    textNode,
    rootElement,
    maximumHeight,
    ellipsisCharacter
  )
}

const TRAILING_WHITESPACE_AND_PUNCTUATION_REGEX = /[ .,;!?'‘’“”\-–—]+$/

function truncateTextNodeByCharacter (
  textNode,
  rootElement,
  maximumHeight,
  ellipsisCharacter
) {
  let textContent = textNode.textContent
  let length = textContent.length
  while (length > 1) {
    // Trim off one trailing character and any trailing punctuation and whitespace.
    textContent = textContent
      .substring(0, length - 1)
      .replace(TRAILING_WHITESPACE_AND_PUNCTUATION_REGEX, '')
    length = textContent.length
    textNode.textContent = textContent + ellipsisCharacter
    if (rootElement.scrollHeight <= maximumHeight) {
      return true
    }
  }
  return false
}
